import { render, staticRenderFns } from "./commentsWriteBox.vue?vue&type=template&id=4251b9ec&scoped=true&"
import script from "./commentsWriteBox.vue?vue&type=script&lang=js&"
export * from "./commentsWriteBox.vue?vue&type=script&lang=js&"
import style0 from "./commentsWriteBox.vue?vue&type=style&index=0&id=4251b9ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4251b9ec",
  null
  
)

export default component.exports